<form
  *ngIf="initialized && bookmarkCategoryStore.asArray() as categories"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Name'"
      [name]="'title'"
      [formField]="form.get('title')">
      <input
        pInputText
        id="title"
        type="text"
        formControlName="title"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Überschrift'" [name]="'headline'">
      <input
        pInputText
        id="headline"
        type="text"
        formControlName="headline"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper label="Themenbereich" name="parent">
      <p-dropdown
        id="category"
        formControlName="category"
        [showClear]="true"
        [filter]="categories.length > 10"
        [filterFields]="['title']"
        [options]="categories"
        optionLabel="title"
        optionValue="_id"
        dataKey="_id">
        <ng-template pTemplate="header">
          <div class="p-2 border-bottom-1 surface-border">
            <p-button
              styleClass="w-auto"
              [text]="true"
              [rounded]="true"
              (onClick)="openBookmarkCategoryForm()"
              icon="fas fa-plus"
              label="hinzufügen"></p-button>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <i class="fas fa-layer-group"></i>
            <div>{{ item.title }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </app-form-field-wrapper>

    <app-tag-dropdown formControlName="tags" mode="all"></app-tag-dropdown>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'öffentlich sichtbar'"
      [name]="'published'">
      <p-inputSwitch id="published" formControlName="published"></p-inputSwitch>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [colSize]="6"
      [label]="'Jahresnavigation ausblenden'"
      name="disableControls">
      <p-inputSwitch
        id="disableControls"
        formControlName="disableControls"></p-inputSwitch>
    </app-form-field-wrapper>
    @if (
      !itemToEdit ||
      (itemToEdit &&
        this.activeUserStore.user() &&
        itemToEdit.user === this.activeUserStore.user()?._id)
    ) {
      <app-form-field-wrapper
        [colSize]="6"
        [label]="'privat'"
        [name]="'published'">
        <p-inputSwitch id="published" formControlName="private"></p-inputSwitch>
      </app-form-field-wrapper>
    }
    <!--
    <app-form-field-wrapper
      [colSize]="6"
      label="als Vorlage speichern"
      name="useAsTemplate"
      [floatingLabel]="false">
      <p-inputSwitch
        id="useAsTemplate"
        formControlName="useAsTemplate"></p-inputSwitch>
    </app-form-field-wrapper>-->

    <app-alert
      header="Fehlende Konfiguration"
      class="px-2 w-full"
      [canToggle]="false"
      *ngIf="itemToEdit && !itemToEdit.config">
      <p class="m-0">Die Ansicht hat noch keine Konfiguration</p>
      <p>
        <a href="#">Jetzt konfigurieren <i class="fas fa-arrow-right"></i></a>
      </p>
    </app-alert>
  </div>

  <p-divider></p-divider>

  <app-form-footer
    [cancelLevel]="atlasForm ? 0 : 1"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        itemToEdit._id &&
        itemToEdit.category &&
        permissionService.checkBookmarkRights(itemToEdit.category, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit?._id"
    (cancel)="cancel.emit()"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
